/** @param {string} path The path of the file (including folder and extension) */
export var staticUrl = function staticUrl(path) {return "https://static.navegate.com/".concat(path);};
//# sourceMappingURL=urls.js.map